import Sidebar from './Sidebar';
import Header from './Header';
import Footer from '../components/Footer';
import { useEffect } from 'react';

export default function MainLayout({ children }) {
  // Ensure dark mode is set on initial load
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const theme = localStorage.getItem('theme');
      if (theme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-blue-50 dark:bg-blue-950">
      <div className="flex flex-1">
        <Sidebar />
        <div className="flex-1 flex flex-col h-screen overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto p-6 bg-gradient-to-br from-white to-sky-50 dark:from-gray-900 dark:to-blue-950">
            {children}
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
}
